import { ChevronLeft, ChevronRight } from "lucide-react";
import React from "react";

interface ChangeHistoryPaginationProps {
  pageNumber: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  isVisible: boolean;
}

const ChangeHistoryPagination: React.FC<ChangeHistoryPaginationProps> = ({
  pageNumber,
  totalPages,
  onPageChange,
  isVisible,
}) => {
  if (!isVisible || totalPages <= 1) {
    return null;
  }

  return (
    <div className="tw-px-6 tw-py-4 tw-border-t tw-border-border tw-flex tw-items-center tw-justify-between">
      <div className="tw-text-sm tw-text-foreground/60">
        Page <span className="tw-font-semibold tw-text-foreground">{pageNumber}</span> of{" "}
        <span className="tw-font-semibold tw-text-foreground">{totalPages}</span>
      </div>

      <div className="tw-flex tw-items-center tw-gap-2">
        {/* Previous Button */}
        <button
          onClick={() => onPageChange(Math.max(1, pageNumber - 1))}
          disabled={pageNumber === 1}
          className="tw-p-2 tw-rounded tw-border tw-border-border tw-text-foreground hover:tw-bg-foreground/5 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-transition-colors"
          title="Previous page"
        >
          <ChevronLeft className="tw-h-4 tw-w-4" />
        </button>

        {/* Page Numbers */}
        <div className="tw-flex tw-items-center tw-gap-1">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className={`tw-px-2.5 tw-py-1 tw-rounded tw-text-sm tw-font-medium tw-transition-colors ${
                pageNumber === page
                  ? "tw-bg-primary tw-text-primary-foreground"
                  : "tw-border tw-border-border tw-text-foreground hover:tw-bg-foreground/5"
              }`}
            >
              {page}
            </button>
          ))}
        </div>

        {/* Next Button */}
        <button
          onClick={() => onPageChange(Math.min(totalPages, pageNumber + 1))}
          disabled={pageNumber === totalPages}
          className="tw-p-2 tw-rounded tw-border tw-border-border tw-text-foreground hover:tw-bg-foreground/5 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-transition-colors"
          title="Next page"
        >
          <ChevronRight className="tw-h-4 tw-w-4" />
        </button>
      </div>
    </div>
  );
};

export default ChangeHistoryPagination;
